import './inbox_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.AttachmentFactory extends Backbone.Model

  initialize: (media, social_content) =>
    @media = media
    @social_content = social_content

  get_attachment:=>
    if @social_content.type() == 'twitter' && @social_content.canPlayVideoType('video/mp4')
      if _.contains(['video'], @media.type) && @has_video_variants()
        attachment = @twitter_video_attachment()
      else
        if _.contains(['animated_gif'], @media.type) && @has_video_variants()
          attachment = @twittter_gif_attachment()
        if _.contains(['photo'], @media.type) || !@has_video_variants()
          attachment = @media_attachment()
    else
      attachment = @media_attachment()
    attachment

  twitter_video_attachment:=>
    #videos = _.filter(@medias, (media)=> media.type == 'video')
    #@video_attachments = _.map(videos, (media)=> new Monitoring.Models.SocialContents.TwitterVideoAttachment(media))
    new Monitoring.Models.SocialContents.TwitterVideoAttachment(@media)

  #image_attachments:=>
  #  images = _.filter(@medias, (media)=>media.type == 'photo')
  #  @image_attachments = _.map(images, (media)=> new Monitoring.Models.SocialContents.ImageAttachment(media))

  #has_image_attachments:=>
  #  @image_attachments.length !=0

  twittter_gif_attachment:=>
    #gifs = _.filter(@medias, (media)=>media.type == 'animated_gif')
    #@gif_attachments = _.map(gifs, (media)=> new Monitoring.Models.SocialContents.TwitterGifAttachment(media))
    new Monitoring.Models.SocialContents.TwitterGifAttachment(@media)

  media_attachment: =>
    new Monitoring.Models.SocialContents.MediaAttachment(@media)

  has_video_variants: =>
    @media.video_info?.variants?.length > 0
